import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Plane } from "lucide-react";

const Loader = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
    <Plane className="w-8 h-8 text-primary animate-pulse" />
    <p className="text-muted-foreground text-sm tracking-widest uppercase">Loading</p>
  </div>
);

export const ProtectedRoute = ({ children, role }) => {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;
  }
  return children;
};
